import { render, staticRenderFns } from "./loadscript.vue?vue&type=template&id=2dd8df3c"
import script from "./loadscript.vue?vue&type=script&lang=js"
export * from "./loadscript.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports